import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AddSignalRegistrationComponent } from '../modules/vik/components/modals/add-signal-registration/add-signalRegistration.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Organization, RegisterSignalClient, RegisteredSignal, UserProfile } from '../web-api-client';
import { WtStorageService } from '../wt-storage.service';
import { User } from '../modules/admin/users/users.component';
import { AddEmergencyComponent } from '../modules/vik/components/modals/add-emergency/add-emergency.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit {

  public isLoading: boolean = true;
  public isWidgetRefreshed: boolean = false;

  public user: UserProfile;
  public unconvertedRegisteredSignalsList: RegisteredSignal[] = [];

  // Date range filter properties
  public startDate: string;
  public endDate: string;

  constructor(private readonly modalService: NgbModal, public _cdr: ChangeDetectorRef,public signalClient:RegisterSignalClient, public cacheService: WtStorageService) {


    console.log('## trigger home constructor')

    // Initialize date range to one year ago to today
    this.initializeDateRange();

  }
  ngOnInit(): void {


    console.log('## trigger home init')

    this.signalClient.getClosedfList().subscribe(r => {

      console.log('## trigger home load data')

      this.unconvertedRegisteredSignalsList = r;
      this.user = this.cacheService.getuser();
      this.isLoading = false;
      this._cdr.detectChanges();
    },(err)=>console.log('### error '+err));


  }

  private initializeDateRange(): void {
    const today = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    const oneYearAhead = new Date();
    oneYearAhead.setFullYear(today.getFullYear() + 1);

    // Format dates as YYYY-MM-DD for HTML date input (1 year behind to 1 year ahead)
    this.startDate = this.formatDateForInput(oneYearAgo);
    this.endDate = this.formatDateForInput(oneYearAhead);
  }

  private formatDateForInput(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  public onDateRangeChange(): void {
    // Toggle the refresh flag to trigger widget updates
    this.isWidgetRefreshed = !this.isWidgetRefreshed;
    this._cdr.detectChanges();
  }

  public clearDateRange(): void {
    this.initializeDateRange();
    this.isWidgetRefreshed = !this.isWidgetRefreshed;
    this._cdr.detectChanges();
  }

  public showVIkModuleElements(): boolean {
    return this.user.organization.enableVikModule;
  }

  public onAddNewEmergencyClicked() {
    const modalRef = this.modalService.open(AddEmergencyComponent, { size: 'xl', centered: true });
    const componentInstance = <AddEmergencyComponent>modalRef.componentInstance;
    componentInstance.closedSignalsList = this.unconvertedRegisteredSignalsList;
    componentInstance.onEmergencyCreated.subscribe(registeredEmergency => {


    })

  }

  public onCreation(): void {
    const modalRef = this.modalService.open(AddSignalRegistrationComponent, { size: 'xl', centered: true });
    const componentInstance = <AddSignalRegistrationComponent>modalRef.componentInstance;
    componentInstance.onClose.subscribe(r => {

    });
  }

  public isRegisterSignalVisible(): boolean {

    if (this.user.userProfession.title != "Диспечер")
      return false;


    return true;
  }

  public onSignalsRefresh(isRefreshed: any) {

    this.isWidgetRefreshed = !this.isWidgetRefreshed;
    this._cdr.detectChanges();
  }

}
